import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import PublishedWorks from './components/PublishedWorks';
import AuthorUpdates from './components/AuthorUpdates';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-8 py-6 flex items-center justify-between">
          <button 
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="flex items-center cursor-pointer"
          >
            <img 
              src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/a9c8693f09f8b92c748c8dc77e0b8d5b.jpeg" 
              alt="Author Logo" 
              className="h-12 w-12 rounded-full object-cover"
            />
          </button>
          <div className="flex items-center gap-12">
            <button 
              onClick={() => scrollToSection('about')}
              className={`text-base font-light transition-colors hover:text-[#C9A961] cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-[#2C2C2C]' : 'text-white'
              }`}
            >
              Biography
            </button>
            <button 
              onClick={() => scrollToSection('works')}
              className={`text-base font-light transition-colors hover:text-[#C9A961] cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-[#2C2C2C]' : 'text-white'
              }`}
            >
              Published Works
            </button>
            <button 
              onClick={() => scrollToSection('updates')}
              className={`text-base font-light transition-colors hover:text-[#C9A961] cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-[#2C2C2C]' : 'text-white'
              }`}
            >
              Updates
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className={`text-base font-light transition-colors hover:text-[#C9A961] cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-[#2C2C2C]' : 'text-white'
              }`}
            >
              Contact
            </button>
          </div>
        </div>
      </nav>

      <Hero scrollToSection={scrollToSection} />
      <About />
      <PublishedWorks />
      <AuthorUpdates />
      <Testimonials />
      <Contact />
      <Footer scrollToSection={scrollToSection} />
    </div>
  );
}
